import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStorage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconStorage"><Path d="M17 17H15V19H17V17Z" fill="currentColor"/><Path d="M12 17H14V19H12V17Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20 2H4V22H20V2ZM6 16H18V20H6V16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStorage;
